module.exports = __webpack_public_path__ + "static/media/Path 14.ac4c6f9e.svg";